<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Training Bulk Update</h3>
</div>
<div class="modal-body">
    <p>The following training codes will added for the following employees.</p>
    <hr />
    <div class="row">
        <div class="col-lg-6">
            <ul style="list-style:none;padding-left:0px;margin-top:25px;">
                <li>
                    <div>
                        <b>Code</b>
                    </div>
                </li>
                <div style="max-height:400px;overflow-x:hidden;">
                    <li *ngFor="let data of trainData" style="margin-bottom:5px;">
                        <div style="margin-left:15px;">
                            {{data.CodeType}} - {{data.CodeDescription}}
                        </div>
                    </li>
                </div>
            </ul>
        </div>
        <div class="col-lg-6">
            <ul style="list-style:none;padding-left:0px;margin-top:25px;">
                <li>
                    <div>
                        <b>Employee</b>
                    </div>
                </li>
                <div style="max-height:400px;overflow-x:hidden;">
                    <li *ngFor="let data of employeeData" style="margin-bottom:5px;">
                        <div style="margin-left:15px;">
                            {{data.FullName}}
                        </div>
                    </li>
                </div>
            </ul>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="confirmClicked()">Confirm</button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>